module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "fullpage"
    }
  }, [_c('header-slide'), _vm._v(" "), _c('idea-slide'), _vm._v(" "), _c('club-slide'), _vm._v(" "), _c('support-slide'), _vm._v(" "), _c('blog-slide')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c8c7d5e!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/TopPage.vue
// module id = 385
// module chunks = 2